import React, { useContext } from 'react';
import { Trans } from '@lingui/react';
import TextWithIcon from './../components/TextWithIcon';
import LoginModal from './../organisms/modals/LoginModal';
import PlaylistModal from './../organisms/modals/PlaylistModal';
import { UserContext } from '@lib/contexts/UserProvider';

const ButtonEditPlaylist = props => {
  const DynamicComponent = props.tag;
  const [currentUser, { loading }] = useContext(UserContext);

  if (loading) {
    return (
      <DynamicComponent {...props} disabled={loading}>
        <Trans id="metadata.please_wait" message={`Please wait...`} />
      </DynamicComponent>
    );
  }
  if (currentUser && currentUser.id !== props.playlist.ownerId) {
    return null;
  }
  if (!currentUser?.id) {
    return (
      <LoginModal>
        {handleOpenModal => (
          <DynamicComponent {...props} onClick={handleOpenModal}>
            <Trans id="metadata.login" message={`Login`} />
          </DynamicComponent>
        )}
      </LoginModal>
    );
  } else if (currentUser?.id) {
    return (
      <PlaylistModal playlist={props.playlist}>
        {handleOpenModal => (
          <DynamicComponent {...props} onClick={handleOpenModal}>
            <TextWithIcon icon="ygb-icon-edit" iconSize="15px">
              <Trans id="metadata.edit_playlist" message="Edit Playlist" />
            </TextWithIcon>
          </DynamicComponent>
        )}
      </PlaylistModal>
    );
  }
};

export default ButtonEditPlaylist;
